export const FPS = 30;
export const DURATION_PER_IMAGE = 3.5; // segundos
export const END_SCREEN_DURATION = 4; // segundos
export const WIDTH = 1080;
export const HEIGHT = 1920;